import axios from 'axios';
import { getStoredAuthToken, removeStoredAuthToken } from './authToken';
import JsFileDownloader from 'js-file-downloader';
import {getBaseUrl} from '../settings';

const defaults = {
    baseURL: getBaseUrl(),
    headers: () => ({
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json',
        Authorization: getStoredAuthToken() ? `Bearer ${getStoredAuthToken()}` : undefined,
    }),
    error: {
        code: 'INTERNAL_ERROR',
        message: 'Something went wrong. Please check your internet connection or contact our support.',
        status: 503,
        data: {},
    },
};

const api = async (method, url, variables, fullfill, reject) => {
    let formData = new FormData();
    if (variables) {
        for (const property in variables) {
            if (variables[property] === null) {
                formData.append(property, "");
            } else {
                formData.append(property, variables[property]);
            }
        }
    }

    await axios({
        headers: defaults.headers(),
        baseURL: defaults.baseURL,
        url: url,
        method,
        params: method !== 'post' ? variables : undefined,
        data: method !== 'get' ? formData : undefined,
    }).then(response => {
        fullfill(response);
    }, error => {
        if (error.response) {
            if (error.response.status === 401) { //Unauthorized
                resetToken();
                // console.log(error.response);
            } else {
                reject(error.response);
                console.log(error.response);
            }
        } else {
            reject(defaults.error);
        }
    })
}

const resetToken = () => {
    removeStoredAuthToken();
    let getUrl = window.location;
    let baseUrl = getUrl .protocol + "//" + getUrl.host;
    window.location.replace(baseUrl);
}

const batchGet = async (urls) => {
    let data = [];
    for (let i = 0; i < urls.length; i += 4) { //Chunk request to four request
        let chunkUrls = urls.slice(i, i+4);

        try {
            const res = await Promise.all(chunkUrls.map((url) => (axios.get(url, {headers: defaults.headers()})) ));

            data = [...data, ...res.map((res) => res.data)]

        } catch (error) {
            throw Error(error);
        }
    }

    return data;

}

const downloadFile = (path) => {
    new JsFileDownloader({
        url: path,
        headers: [
            {
                name: 'Authorization', value: getStoredAuthToken() ? `Bearer ${getStoredAuthToken()}` : undefined,
            }
        ]
    })
        .then(function () {
            // Called when download ended
        })
        .catch(function (error) {
            // Called when an error occurred
        });
}

const upload = (file, URI, onProgress, onFinish, onError, params={}) => {
    const config = {
        headers: defaults.headers(),
        onUploadProgress: function(progressEvent) {
            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            onProgress(percentCompleted);
        }
    };

    const source = axios.CancelToken.source();

    let formData = new FormData();

    formData.append(file.name, file.file);

    for (const param in params) {
        formData.append(`${param}`, `${params[param]}`);
    }

    axios.post(defaults.baseURL + URI, formData, config)
        .then(res => onFinish(res))
        .catch(err => onError(err));

    return source;
};

const cancelUpload = (source) => {
    source.cancel('Upload canceled by user');
};

export default {
    get: (url, variables, fullfill, reject) => api('get', url, variables, fullfill, reject),
    post: (url, variables, fullfill, reject) => api('post', url, variables, fullfill, reject),
    put: (url, variables, fullfill, reject) => api('put', url, variables, fullfill, reject),
    delete: (url, variables, fullfill, reject) => api('delete', url, variables, fullfill, reject),
    batchGet: (urls) => batchGet(urls),
    downloadFile: (path) => downloadFile(path),
    upload: (file, URI, onProgress, onFinish, onError, params) => upload(file, URI, onProgress, onFinish, onError, params),
    cancelUpload: (source) => cancelUpload(source),
}
